import {Injectable, OnDestroy} from '@angular/core';
import {ConsultationCategoryModel} from '../model/consultationCategory.model';
import {ConsultationCategorySummaryModel} from '../model/consultationCategorySummary.model';
import {
    ConsultationCategorySummaryDataServiceAdapter
} from '../../impl/service/ngrx/consultationCategorySummaryDataService.adapter';
import {ConsultationCategoryRepository} from '../../impl/service/ngrx/consultationCategory.repository';
import {
    AgendaCategoryHolderFindAllService
} from '../../../../../agenda/modules/category/api/service/agendaCategoryHolderFindAll.service';
import {AgendaContext} from '../../../../../agenda/modules/event/api/entity/agendaEvent.model';

@Injectable()
export class ConsultationCategoryFindAllSummaryService
    extends AgendaCategoryHolderFindAllService<ConsultationCategoryModel, ConsultationCategorySummaryModel>
    implements OnDestroy{

    constructor(repository: ConsultationCategoryRepository, dataServiceAdapter: ConsultationCategorySummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }



    get agendaContext(): AgendaContext {
        return AgendaContext.MEDICAL;
    }

    resolveSortKeyLabel(value: string): string {
        switch(value) {
            case 'date': return 'Date';
            case 'category.name': return "Catégorie de consultation";
        }
        return value;
    }
}
